import type { AdoptionJourneyInput } from "@/features/adoption-journey";
import { getListingDetail, ListingPageSkeleton } from "@/features/listings";
import { toAdoptionJourneyInput } from "./adoption-journey-input.ts";

async function loadAdoptionJourney(
    dogId: string,
): Promise<AdoptionJourneyInput | null> {
    const dog = await getListingDetail({ data: { listingId: dogId } });
    return dog ? toAdoptionJourneyInput(dogId, dog) : null;
}

export const adoptionJourneyPageRoute = {
    ssr: false,
    loader: async ({ params }: { params: { dogId: string } }) =>
        loadAdoptionJourney(params.dogId),
    head: () => ({ meta: [{ title: "Adoption journey | Wags" }] }),
    pendingComponent: ListingPageSkeleton,
};
